import React from 'react';
import { Icon } from './Icon.js';
export const IconBoltAuto = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M15.376 20H20.376", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M19.3008 14.6191L22.752 23H20.5889L17.876 16.4121L15.1631 23H13L16.4512 14.6191L16.7061 14H19.0459L19.3008 14.6191Z", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("path", { d: "M10 8H16V8.8L8.8125 18H8V12H2V11.2L9.1875 2H10V8Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconBoltAuto.js.map